<template>
  <div>
    <Head :title="`Transferencia #${depositTransfer.id}`" />

    <!-- Encabezado y Navegación -->
    <div class="mb-8 flex items-center justify-between">
      <div class="flex items-center gap-4">
        <Link 
          :href="`/deposits/${depositId}/transfer`" 
          class="text-gray-500 hover:text-gray-700 flex items-center gap-2 text-sm font-medium"
        >
          <i class="fa fa-arrow-left"></i>
          <span>Volver a Transferencias</span>
        </Link>
        <h1 class="text-2xl font-bold text-gray-800">
          Transferencia #{{ depositTransfer.id }}
        </h1>
      </div>
    </div>

    <!-- Tarjeta de Información General -->
    <div class="bg-white rounded-lg shadow-sm p-6 mb-6">
      <h2 class="text-lg font-semibold text-gray-800 mb-4 border-b pb-2">
        Información de la Transferencia
      </h2>
      <div class="grid grid-cols-1 md:grid-cols-4 gap-6">
        <div>
          <span class="block text-xs font-medium text-gray-500 uppercase">Depósito Emisor</span>
          <span class="text-base font-semibold text-gray-900">
            {{ depositTransfer.emitter?.name || 'N/A' }}
          </span>
        </div>

        <div>
          <span class="block text-xs font-medium text-gray-500 uppercase">Depósito Receptor</span>
          <span class="text-base font-semibold text-gray-900">
            {{ depositTransfer.receiver?.name || 'N/A' }}
          </span>
        </div>

        <div>
          <span class="block text-xs font-medium text-gray-500 uppercase">Fecha</span>
          <span class="text-base text-gray-900">
            {{ formatDate(depositTransfer.date) }}
          </span>
        </div>

        <div>
          <span class="block text-xs font-medium text-gray-500 uppercase">Estado</span>
          <span 
            class="mt-1 px-3 py-1 inline-flex text-xs leading-5 font-semibold rounded-full"
            :class="getStateClass(depositTransfer.state)"
          >
            {{ getStateLabel(depositTransfer.state) }}
          </span>
        </div>
      </div>
    </div>

    <!-- Tabla de Productos Transferidos -->
    <div class="bg-white rounded-lg shadow-sm overflow-hidden">
      <div class="p-4 bg-gray-50 border-b">
        <h2 class="text-lg font-semibold text-gray-800">Productos Transferidos</h2>
      </div>

      <div class="overflow-x-auto">
        <table class="w-full">
          <thead class="bg-gray-100">
            <tr>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                Código
              </th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                Producto
              </th>
              <th class="px-6 py-3 text-center text-xs font-medium text-gray-600 uppercase tracking-wider">
                Cantidad
              </th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                IMEIs Transferidos
              </th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-200">
            <tr 
              v-for="item in depositTransfer.products" 
              :key="item.id"
              class="hover:bg-gray-50"
            >
              <td class="px-6 py-4 text-sm text-gray-900 font-mono">
                {{ item.product?.code || 'N/A' }}
              </td>
              <td class="px-6 py-4 text-sm text-gray-900 font-medium">
                {{ item.product?.name || 'Producto eliminado' }}
              </td>
              <td class="px-6 py-4 text-sm text-center text-gray-900 font-bold">
                {{ Number(item.quantity) }}
              </td>
              <td class="px-6 py-4 text-sm">
                <div v-if="item.imeis && item.imeis.length" class="flex flex-wrap gap-1.5">
                  <span 
                    v-for="imei in item.imeis" 
                    :key="imei"
                    class="bg-indigo-50 text-indigo-700 px-2 py-0.5 rounded text-xs font-mono border border-indigo-200 shadow-sm"
                  >
                    <i class="fa fa-barcode mr-1 text-indigo-500"></i>
                    {{ imei }}
                  </span>
                </div>
                <span v-else class="text-gray-400 text-xs italic">
                  Sin IMEIs
                </span>
              </td>
            </tr>

            <tr v-if="!depositTransfer.products || !depositTransfer.products.length">
              <td colspan="4" class="px-6 py-8 text-center text-gray-500 text-sm">
                No hay detalles de productos registrados para esta transferencia.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import { formatDate } from '@/utils/format'

export default {
  name: 'TransferShow',

  components: {
    Head,
    Link,
  },

  layout: Layout,

  props: {
    depositId: Number,
    depositTransfer: Object,
  },

  methods: {
    formatDate,

    getStateClass(state) {
      const classes = {
        'prepared': 'bg-yellow-100 text-yellow-800',
        'in_transit': 'bg-blue-100 text-blue-800',
        'completed': 'bg-green-100 text-green-800',
        'cancelled': 'bg-red-100 text-red-800',
      }
      return classes[state] || 'bg-gray-100 text-gray-800'
    },

    getStateLabel(state) {
      const labels = {
        'prepared': 'Preparada',
        'in_transit': 'En Tránsito',
        'completed': 'Completada',
        'cancelled': 'Cancelada',
      }
      return labels[state] || state
    },
  },
}
</script>
